import axios from "axios";

import { IExternalListPage } from "../../types/api";

export interface IAmazonEtdResult {
    id: string;
    configId: string;
    pincode: string;
    etdText: string | null;
    estimatedDays: number | null;
    deliverable: boolean;
    scrapedAt: string;
    asin: string;
    createdAt: string;
}

export interface IAmazonEtdConfig {
    id: string;
    variantId: string;
    asin: string;
    createdAt: string;
    deletedAt: string | null;
}

export interface IGetAmazonEtdResultsParameters {
    limit: number;
    cursor?: string;
    direction?: string;
    asin?: string;
    pincode?: string;
    startDate?: string;
    endDate?: string;
    token: string;
}

export interface IGetAmazonEtdConfigsParameters {
    limit: number;
    cursor?: string;
    direction?: string;
    token: string;
}

export interface IGetAsinsParameters {
    token: string;
}

export interface IAsinOption {
    asin: string;
    productTitle: string;
    variantTitle: string;
}

export class AmazonEtd {
    static async getResults(
        parameters: IGetAmazonEtdResultsParameters,
    ): Promise<IExternalListPage<IAmazonEtdResult>> {
        const {
            token,
            cursor,
            limit,
            direction,
            asin,
            pincode,
            startDate,
            endDate,
        } = parameters;

        const params = new URLSearchParams();

        if (cursor) {
            params.append("cursor", cursor);
        }

        if (direction) {
            params.append("direction", direction);
        }

        if (limit) {
            params.append("limit", limit.toString());
        }

        if (asin) {
            params.append("asin", asin);
        }

        if (pincode) {
            params.append("pincode", pincode);
        }

        if (startDate) {
            params.append("startDate", startDate);
        }

        if (endDate) {
            params.append("endDate", endDate);
        }

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/amazon-etd/results?${params}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }

    static async getConfigs(
        parameters: IGetAmazonEtdConfigsParameters,
    ): Promise<IExternalListPage<IAmazonEtdConfig>> {
        const { token, cursor, limit, direction } = parameters;

        const params = new URLSearchParams();

        if (cursor) {
            params.append("cursor", cursor);
        }

        if (direction) {
            params.append("direction", direction);
        }

        if (limit) {
            params.append("limit", limit.toString());
        }

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/amazon-etd/configs?${params}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }

    static async getDistinctAsins(
        parameters: IGetAsinsParameters,
    ): Promise<IAsinOption[]> {
        const { token } = parameters;

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/admins/v1/amazon-etd/asins`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "Admin-Request": "true",
                },
            },
        );
        return data;
    }
}
